import { Record } from 'immutable';

const BestIncentivesRecord = Record({
    manufacturerRebates: 0, // 1500 Manufacturer's total incentive rebates and discounts.
    manufacturerRebatesWithoutTaxes: 0,
    governmentRebates: 0, // 5500 Government's total subsidies, refunds and rebates (such as electric rebate) for the vehicle.
    governmentRebatesWithoutTaxes: 0,
    dealerRebates: 0, // 115 Dealer's discount for the vehicle.
    dealerRebatesWithoutTaxes: 0,
    total: 0, // 7115 The sum of all discounts and rebates for the vehicle.
    totalWithoutTaxes: 0,
    deliveryBonus: 0, //
    electricRebateIncluded: false, // Flag to identify when the electric rebate is included in total rebates.
});

class BestIncentivesModelV25 extends BestIncentivesRecord {}

export default BestIncentivesModelV25;
